import { Editor } from "./Editor.js";
import * as dtv from "../../data/values.js";
import { Services } from "../../services/Services.js";

export class DurationBox extends Editor {

    constructor(parent, options = {}) {

        super(parent, options);

        const {
            onFormatValue = null,
            onParseValue = null,
            multiline = false,
            autoclose = false,
        } = options;

        this.onFormatValue = onFormatValue;
        this.onParseValue = onParseValue;
        this.multiline = multiline;
        this.autoclose = autoclose;

    }

    isAutofocus() {

        return (typeof this.autofocus === 'function') ? this.autofocus.call(this) : this.autofocus;

    }

    isAutoclose() {

        return (typeof this.autoclose === 'function') ? this.autoclose.call(this) : this.autoclose;

    }

    render(vm) {

        const ct = Services.get('templates');

        var that = this,
            value = this.getValue(),
            style = this.getCss(),
            props = {
                id: this.getId(),
                visible: this.isVisible(),
                onchange: onValueChange,
                'data-focus': !(this.isDisabled() || this.isReadOnly()) && this.isAutofocus() ? 'auto' : null,
            },
            params = {

            },
            oldValue = '';

        if (this.isReadOnly() || this.isDisabled()) {
            props.readonly = 'readonly';
        }

        if (typeof this.onFormatValue == 'function')
            value = this.onFormatValue(value);
        else
            value = dtv.formatTimespan(value);


        if (this.immediateValueChange) {
            props.onkeyup = onValuePossibleChange;
        }

        return ct.textBox(value, style, props, params);

        function onValueChange(e, node) {
            var value = e.target.value;
            if (typeof that.onParseValue == 'function')
                value = that.onParseValue(value);
            else
                value = dtv.parseTimespan(value)
            that.changeValue(value);
        }

        function onValuePossibleChange(e, node) {
            var value = e.target.value;
            if (value == oldValue)
                return;
            oldValue = value;
            that.changeValue(value);
        }

    }

}